import React from "react";
import {Box} from "@mui/material";
import GridCard from "../../components/deprecatedUikit/GridCard/GridCard";
import {BookingTransactionType, BookingTransactionTypeLabel} from "../../components/constants/securspace-constants";
import {headerCells, agsHeaderCells} from "./data";

const InvoicesInPayoutCard = ({invoices, handleSortChange}) => {

  return (
    <Box mt={4}>
      {invoices.length > 0 && invoices.map(invoice => (
        <GridCard
          key={invoice.transactionNumber}
          cardStyles={{marginBottom: '1.5rem'}}
          listId={invoice.transactionNumber}
          data={invoice}
          handleSortChange={handleSortChange}
          menuCloseListener={null}
          menuOpenListener={null}
          menuOptions={null}
          headData={invoice.transactionType === BookingTransactionTypeLabel[BookingTransactionType.AGS_FEE] ? agsHeaderCells : headerCells}
        />
      ))
      }
    </Box>
  );
}

export default InvoicesInPayoutCard;
